module.exports = __webpack_public_path__ + "img/color-companion-2_jp.d59f13d.jpg";